module.exports = __webpack_public_path__ + "img/gb13871-92_100x125x12.prt.b5487847.jpg";